import type { PageHeaderTint } from '@/lib/pageHeaderTint'
import Breadcrumbs from '@/components/site/Breadcrumbs'
import '@/styles/page-hero-bar.css'

type Props = {
  title: string
  subtitle?: string
  /** Optional: smaller eyebrow line above the title */
  kicker?: string
  tint: PageHeaderTint
  className?: string
  /** Breadcrumb trail at bottom of tinted hero with divider above it */
  breadcrumbsBelow?: boolean
}

export default function PageHeroBar({
  title,
  subtitle,
  kicker,
  tint,
  className = '',
  breadcrumbsBelow = true,
}: Props) {
  return (
    <div className={`page-hero-bar page-hero-bar--${tint} ${className}`.trim()}>
      <div className="page-hero-bar-main">
        {kicker ? <p className="page-hero-bar-kicker">{kicker}</p> : null}
        <h1 className="page-hero-bar-title">{title}</h1>
        {subtitle ? <p className="page-hero-bar-sub">{subtitle}</p> : null}
      </div>
      {breadcrumbsBelow ? (
        <div className="page-hero-bar-footer">
          <Breadcrumbs className="site-breadcrumbs--in-hero" />
        </div>
      ) : null}
    </div>
  )
}
